import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import InvoicesList from "./invoiceslist";
import Footer from "./Footer";
const AdminInvoice = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <InvoicesList />
      <Footer />
    </>
  );
};

export default AdminInvoice;
